import 'whatwg-fetch';
import { emPagination, emLoadMore } from '../pagination';
import { getParams } from './params.js';
import { setActiveFilters, clearFilters } from './active-filters.js';
import { emFetchPosts } from '../../global/helpers.js';

/**
 * Pass parameters and fetch from post factory api.
 * @param  {Object}   element  the element to append/replace the html.
 * @param  {Object}   params   the query parameters to pass to the rest api.
 * @param  {Function} template the html markup.
 */
const getFilterableContent = (element, params = {}) => {
	(async () => {
		// Get the posts
		params.term_counts = true;
		const data = await emFetchPosts(params);

		if (data.posts) {
			// Get the posts from the data.
			const { posts, notFoundMessage } = data; // eslint-disable-line 
			let html = '';

			// Pass the post data to the template.
			posts.forEach((post) => {
				html += `<div class="em-col">${post}</div>`;
			});

			// Output the pagination.
			if (data.pagination === 'load_more') {
				html += emLoadMore(data.max_num_pages, data.current_page);
			} else {
				html += emPagination(data.max_num_pages, data.current_page, 8, 'em-col pagination');
			}

			// Append or replace the markup.
			if (data.pagination === 'load_more' && data.current_page !== 1) {
				element.innerHTML += html;
			} else {
				element.innerHTML = html;
			}

			// No Posts Found
			if (posts.length === 0) {
				element.innerHTML = notFoundMessage;
			}

			// Process the pagination actions.
			const block = document.getElementById(data.block_id);
			const pageNumbers = block.querySelectorAll('.page-numbers, .load-more');
			const filterContainer = block.querySelector('.em-filterable-content__filter-container');
			const contentContainer = block.querySelector('.em-filterable-content__listings');
			const inputs = block.querySelectorAll('input');

			// Loop through page numbers.
			pageNumbers.forEach((page) => {
				page.onclick = (e) => {
					page = e.target;
					page.parentNode.removeChild(page);
					filterContainer.setAttribute('data-page', page.getAttribute('data-page'));

					// Fetch the content.
					getFilterableContent(contentContainer, getParams(block));
				};
			});

			// Set active filter "pills".
			setActiveFilters(block, inputs, getFilterableContent);

			// Initiate clear filters button..
			clearFilters(block, inputs, getFilterableContent);

			// disable terms that don't have posts.
			const { terms } = data;
			inputs.forEach((input) => {
				const termId = input.getAttribute('data-term-id');
				const count = input.nextElementSibling.querySelector('.count');
				if (terms) {
					if (termId in terms) {
						input.removeAttribute('disabled');
						count.innerHTML = `(${terms[termId]})`;
						if (terms[termId] === 0) {
							input.setAttribute('disabled', 'disabled');
							count.innerHTML = '(0)';
						}
					} else if (input.hasAttribute('data-term-id')) {
						input.setAttribute('disabled', 'disabled');
						count.innerHTML = '(0)';
					}
				} else {
					input.removeAttribute('disabled');
					count.innerHTML = '(0)';
				}
			});

			if (data.pagination === 'load_more') {
				const links = block.querySelectorAll('a');
				links.forEach((link) => {
					link.setAttribute('target', '_blank');
					link.setAttribute('rel', 'noopener norefferer');
				});
			}
		}
	})();
};

export default getFilterableContent;
